export default __webpack_public_path__ + "static/media/spiral.4669467d.png";